async function parseCategoryParams(searchParams) {
    const allCategory = {};

    if (_.get(searchParams, 'type', -1) > -1) {
        allCategory.type = _.get(searchParams, 'type');
    }

    if (_.get(searchParams, 'meetingLocation', -1) > -1) {
        allCategory.meetingLocation = _.get(searchParams, 'meetingLocation');
    }

    const isIndependentParam = _.get(searchParams, 'isIndependent', null);
    if (isIndependentParam !== null) {
        allCategory.isIndependentEscortCategory = (isIndependentParam == '1' || isIndependentParam == true);
    }

    const categoriesFromUrl = this.extractCategoriesFromURLPath();
    this.store.commit('setCategory', _.assign({}, allCategory, categoriesFromUrl));
}

function extractCategoriesFromURLPath(path = window.location.pathname || '') {
    let found = null;

    let splited = _.compact(path.split('/'));
    if (splited[0] !== 'sex') {

        const paths = Object.values(_.get(this, 'settings.filter', []))
            .filter(filter => _.get(filter, 'user.user_type', null) !== null)
            .map(filter => {
                const result = {
                    url: _.trim(filter.url, '/'),
                    type: filter.user.user_type,
                }

                const meetingLocation = _.get(filter, 'user.meeting_location', -1);
                if (meetingLocation > -1) {
                    result.meetingLocation = meetingLocation;
                }

                return result;
            })

        found = _.find(paths, (path) => splited.join('/').search(path.url) !== -1);
    }

    return _.pick(found, ['type', 'meetingLocation']);
}

async function generateCategoriesParams(path) {
    let categories = this.category;

    const categoriesFromURLPath = this.extractCategoriesFromURLPath(path);

    if (categoriesFromURLPath) {
        categories = _.omit(categories, Object.keys(categoriesFromURLPath));
    }

    const result = _.omit(categories, ['isIndependentEscortCategory']);

    if (!_.isNil(categories.isIndependentEscortCategory)) {
        result.isIndependent = categories.isIndependentEscortCategory ? '1' : '0';
    }

    return result;
}

const data = () => ({
    store: $store,
});

export default {
    data,
    methods: {
        parseCategoryParams,
        generateCategoriesParams,
        extractCategoriesFromURLPath
    },
    computed: {
        ...mapState([
            'category', 'settings',
        ])
    },
}
